import { Vue, i18n } from 'Common/vue';

// import components
import Autocomplete from './../components/vue/autocomplete/default/Autocomplete.vue';
import Minicart from '../components/vue/Minicart.vue';
import CategoriesFilter from '../components/vue/CategoriesFilter.vue';

import '../ui/toggle';
import './navigation';

window.$_autocomplete = new Vue({
    i18n,
    render: h => h(Autocomplete)
}).$mount("#autocomplete");

const isEstimate = document.querySelector('#minicart').getAttribute('data-is-estimate');
const isEstimateActive = isEstimate == '1' || isEstimate == 1;

window.$_minicart = new Vue({
    i18n,
    render: h => h(Minicart, {
        props: {
            isEstimateActive: isEstimateActive,
        }
    }),

}).$mount("#minicart");

const catFilterElem = document.querySelector('#categoriesFilter');

if (catFilterElem) {
    const productsCategories = catFilterElem.dataset.categories,
        selectedCategoryId = catFilterElem.dataset.selected;

    new Vue({
        el: '#categoriesFilter',
        components: { CategoriesFilter },
        template: `<CategoriesFilter :select-category-id="${selectedCategoryId}" :products-categories="${productsCategories}"></CategoriesFilter>`
    });
}

document.querySelector('.js-trigger-search').addEventListener('click', event => {
    event.preventDefault();

    rEvent.dispatch("Autocomplete.showForm");
});
